import React from "react"
import styled from "@emotion/styled"
import { TextElementMen } from "@nutrafol/nutrafol-ui-kit/dist/TextElementMen"

const FaqFullWrap = styled.div``
const Section = styled.div``

const FaqAlt = ({ questions }) => {
  const buildItems = () => {
    return questions.map((item, idx) => {
      return (
        <Section>
          <TextElementMen
            element="h5"
            text={item.title}
            className="body--regular-b text-men-secondary-secondary"
          />
          <TextElementMen
            element="span"
            text={item.answer}
            className="body--regular-b text-men-secondary-secondary"
          />
        </Section>
      )
    })
  }
  return (
    <FaqFullWrap className={"faq-alt faq-full-wrap"}>
      {buildItems()}
    </FaqFullWrap>
  )
}

export default FaqAlt
